/**
 * Preset picker for one animation channel (in / emphasis / out).
 */

import type { AnimationChannel, AnimationPresetId } from '@canvas/shared-types';
import { presetsByChannel } from '@/data/animationPresets';

interface AnimationPresetGridProps {
  channel: AnimationChannel;
  value: AnimationPresetId;
  onPick: (id: AnimationPresetId) => void;
}

export default function AnimationPresetGrid({ channel, value, onPick }: AnimationPresetGridProps) {
  const presets = presetsByChannel(channel);
  return (
    <div className="vt-anim-grid" role="radiogroup" aria-label={`${channel} animation`}>
      <button
        type="button"
        role="radio"
        aria-checked={value === 'none'}
        className={value === 'none' ? 'active' : ''}
        onClick={() => onPick('none')}
      >
        None
      </button>
      {presets.map((p) => (
        <button
          key={p.id}
          type="button"
          role="radio"
          aria-checked={value === p.id}
          className={value === p.id ? 'active' : ''}
          title={p.hint}
          onClick={() => onPick(p.id)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
